import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable, map,switchMap } from 'rxjs';
import { LocaleService } from '@ciam/library';
import { BypassAssetsInterceptor } from '../bypass-assets/bypass.assets.interceptor';

@Injectable({
  providedIn: 'root'
})

export class LocaleInterceptor extends BypassAssetsInterceptor {
  constructor(
    private localeService: LocaleService
  ) { super(); }

  interceptInternal(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.localeService.watch$().pipe(
      map(locale => locale?.posix),
      map(posix => req.clone({ headers: req.headers.set('x-locale', posix ?? 'en_US') })),
      switchMap(clone => next.handle(clone))
      );
  }
}
